import { useTranslation } from 'react-i18next';
import type { ProjectSlug } from '../data/projects';
import type { ProjectCopy } from '../locales/types';

export function useProjectCopy(): (slug: ProjectSlug) => ProjectCopy {
    const { t } = useTranslation();

    return (slug: ProjectSlug) => t(`projects.${slug}`, { returnObjects: true }) as unknown as ProjectCopy;
}
